import { render, staticRenderFns } from "./ClassroomCreate.vue?vue&type=template&id=760334d0&"
import script from "./ClassroomCreate.vue?vue&type=script&lang=js&"
export * from "./ClassroomCreate.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports